import FormBodyType from './form-body-type.js'
import FormSingleBodyType from './form-single-body-type.js'

export default FormBodyType
export {FormSingleBodyType}
